import {RootStore, stream2string} from "stores";
import {inject, observer} from "mobx-react";
import React, {useEffect, useLayoutEffect, useState} from "react";
import _ from "lodash";
import {CoreFetch, FeeAccrualApi} from "@enter/core";
import * as S from "./invoices.styles";
import {ContactSupport, PageLayoutRow} from "components";

export const Invoices = inject('rootStore')(
    observer((props: {}) => {
        const rootStore: RootStore = _.get(props, 'rootStore');
        if (!rootStore) {
            return <></>;
        }

        const [loading, setLoading] = useState(true);
        const [unavailable, setUnavailable] = useState(false);
        const [error, setError] = useState(false);
        const [billingUrl, setBillingUrl] = useState('');

        document.title = 'Provider Dashboard - Bills';

        // useLayoutEffect(() => {
        //     // Hide sidebar when open this page
        //     rootStore.layoutStore.toggleSidebar(true);
        // }, []);

        useEffect(() => {
            (async (): Promise<void> => {
                try {
                    setLoading(true);
                    const { url } = await CoreFetch<FeeAccrualApi>(FeeAccrualApi).getProviderFeeAccrualPortal();
                    if(url) {
                        setBillingUrl(url);
                    }
                    setLoading(false);
                } catch (err) {
                    // tslint:disable-next-line: no-console
                    console.error(err);

                    if (err && err.body) {
                        const str = await stream2string(err.body);
                        const msg = JSON.parse(str);
                        if (msg.code === 'err.customer_portal_not_active') {
                            setUnavailable(true);
                        } else {
                            setError(true);
                        }
                    } else {
                        setError(true);
                    }
                    setLoading(false);
                }
            })();
        }, []);

        const renderLoader = (): React.ReactElement => <S.Loader />;
        const renderUnavailable = (): React.ReactElement => (
            <S.Message>
                Sorry! Your account is not configured for embedded billing.
                <ContactSupport action="request access to embedded billing" subject="Requesting access to embedded billing" />
            </S.Message>
        );
        const renderError = (): React.ReactElement => (
            <S.Message>
                Sorry! An error occurred while loading your embedded billing.
                <ContactSupport action="request help or refresh to try again" subject="Need help with embedded billing" />
            </S.Message>
        );
        const renderConditional = (): React.ReactElement | undefined => {
            if (loading) {
                return renderLoader();
            } else if (unavailable) {
                return renderUnavailable();
            } else if (error) {
                return renderError();
            }
        };

        return (
            <S.Wrapper>
                <PageLayoutRow expand={!unavailable}>
                    {renderConditional()}
                    {!unavailable && <S.Embedded id="dashboardContainer">
                        <S.EmbeddedFrame src={billingUrl}/>
                    </S.Embedded>}
                </PageLayoutRow>
            </S.Wrapper>
        );
    }),
);